import { FormBuilder, FormGroup, FormControl, Validators} from '@angular/forms';
import { Component, Input,OnInit, Output, EventEmitter } from '@angular/core';
import { NotificationService, GridDataSource, LoaderService, TYPEPAGE,ErrorService, EVENTO, TOOLTIPS, ICONS, ACTIONS, TYPEMESSAGE, UtilityService } from "../../../../shared/session/index";
import { CustomValidators, RegularExpression, RegularExpressionMessage } from '../../../../shared/validation/customvalidation';
import { Office,Ioffice } from "../shared/office.model";
import { OfficeService } from "../shared/office.service";
import { AplicacionService } from "../../Aplicaciones/shared/aplicacion.service"
import { PageEvent, MatPaginator, MatTableDataSource } from '@angular/material';

@Component({
	//moduleId: module.id,
	selector: 'app-office-view',
	templateUrl: 'office-view.component.html'
})
export class OfficeViewComponent implements OnInit {
  @Input() officeId: number;
	@Output() onChangeEvent: EventEmitter<any> = new EventEmitter();
  @Output() onEmitParam: EventEmitter<any> = new EventEmitter();
  @Input()  data:any;
  @Input() titlePage: string;

  pageEvent: PageEvent;
  office: Ioffice;
	msgErrorGet: string;
	indObteneroffice: boolean;
  dataSource: GridDataSource;

  constructor(private officeService: OfficeService,private notificationService: NotificationService,
    private aplicacionService: AplicacionService,
  private utilityService: UtilityService,private errorService: ErrorService,private loaderService: LoaderService){}

    ngOnInit(){

      this.office = new Office(0,"","","","","",true,"","","","",0,"");
      this.msgErrorGet = 'Error al obtener datos';
      this.obteneroffice(this.data.office.ID);

  }

    private obteneroffice(ID: number): void {
      this.loaderService.show();
      this.officeService.obtenerOffice(ID)
      .subscribe(res => {
          this.office = res;
          this.utilityService.setAuditoria(this.office);
      },
      error => {
          this.notificationService.error(this.msgErrorGet);
          throw error;
      },
      () => {
          this.loaderService.hide();
      });
    }
  }
